module.exports = __webpack_public_path__ + "static/media/wk-exit.ba6083a0.svg";